import { render, staticRenderFns } from "./InsightTripsTable.vue?vue&type=template&id=1d22e674&scoped=true&"
import script from "./InsightTripsTable.vue?vue&type=script&lang=js&"
export * from "./InsightTripsTable.vue?vue&type=script&lang=js&"
import style0 from "./InsightTripsTable.vue?vue&type=style&index=0&id=1d22e674&scoped=true&lang=css&"
import style1 from "./InsightTripsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d22e674",
  null
  
)

export default component.exports